module.exports = __webpack_public_path__ + "static/media/background-2-1267w.cebd19b2.jpg";